import type { MenuItem } from "../menu.type";
import type { NavigationLinkKey } from "@/modules/navigation";

import { Link } from "react-router";

import { useNavigationLink } from "@/modules/navigation";

export const useMenuItemLink = (key: NavigationLinkKey): MenuItem => {
  const link = useNavigationLink(key);

  if (!link) return null;

  const { text, icon, url, external } = link;

  const label = external ? (
    <a href={url} target="_blank" rel="noreferrer">
      {text}
    </a>
  ) : (
    <Link to={url}>{text}</Link>
  );

  return {
    key: external ? `${key}-external-link` : url, // use `url` as key to handle 'active' state
    label,
    icon,
  };
};
